import { render } from "./TimeSwitcher.vue?vue&type=template&id=7b343f00&scoped=true"
import script from "./TimeSwitcher.vue?vue&type=script&lang=js"
export * from "./TimeSwitcher.vue?vue&type=script&lang=js"

import "./TimeSwitcher.vue?vue&type=style&index=0&id=7b343f00&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b343f00"]])

export default __exports__